import { isAllowed } from 'api/Apollo/allower';
import permissions from 'api/Apollo/permissions';

export default function isAllowedToWriteWebhookConfig() {
  return isAllowed(permissions.createWebhookConfig) || isAllowed(permissions.updateWebhookConfig);
}
